var _defs, _g, _path, _path2, _path3, _path4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawerTatabaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2443",
    "data-name": "Group 2443",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.715,
    height: 32.823,
    viewBox: "0 0 79.715 32.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #db2422;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #161615;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2441",
    "data-name": "Group 2441",
    transform: "translate(3.745 16.404)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    className: "cls-1",
    width: 5.314,
    height: 5.314,
    transform: "translate(0.469 4.221) rotate(-45.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    className: "cls-2",
    d: "M232.417,355.865a.469.469,0,0,1-.331-.137l-3.758-3.758a.469.469,0,0,1,0-.663l3.758-3.758a.482.482,0,0,1,.663,0l3.758,3.758a.469.469,0,0,1,0,.663l-3.758,3.758A.469.469,0,0,1,232.417,355.865Zm-3.095-4.226,3.095,3.095,3.095-3.1-3.095-3.095Z",
    transform: "translate(-228.19 -347.418)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    className: "cls-2",
    d: "M356.942,255.514a.469.469,0,0,1-.331-.8l10.629-10.629a.469.469,0,0,1,.663.663l-10.629,10.629A.467.467,0,0,1,356.942,255.514Z",
    transform: "translate(-335.685 -241.291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    className: "cls-2",
    d: "M487.9,226.744l-2.657-2.657a.469.469,0,0,0-.663,0l-2.326,2.326-2.326-2.326a.469.469,0,0,0-.663,0l-2.657,2.657a.469.469,0,0,0,0,.663l2.657,2.657a.469.469,0,0,0,.663,0l2.326-2.326,2.326,2.326a.469.469,0,0,0,.663,0l2.657-2.657a.469.469,0,0,0,0-.663Zm-8.3,2.326-1.994-1.994,1.994-1.994,1.994,1.994Zm5.314,0-1.994-1.994,1.994-1.994,1.994,1.994Z",
    transform: "translate(-439.741 -223.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    className: "cls-2",
    d: "M647.9,226.744l-2.657-2.657a.469.469,0,0,0-.663,0l-2.326,2.326-2.326-2.326a.469.469,0,0,0-.663,0l-2.657,2.657a.469.469,0,0,0,0,.663l2.657,2.657a.469.469,0,0,0,.663,0l2.326-2.326,2.326,2.326a.469.469,0,0,0,.663,0l2.657-2.657a.469.469,0,0,0,0-.663Zm-8.3,2.326-1.994-1.994,1.994-1.994,1.994,1.994Zm5.315,0-1.994-1.994,1.995-1.994,1.994,1.994Z",
    transform: "translate(-578.484 -223.95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    className: "cls-2",
    d: "M399.6,430.2a.466.466,0,0,1-.331-.137l-2.657-2.657a.469.469,0,0,1,0-.663l2.657-2.657a.469.469,0,0,1,.663,0l2.657,2.657a.469.469,0,0,1,0,.663l-2.657,2.657A.467.467,0,0,1,399.6,430.2Zm-1.994-3.125,1.994,1.994,1.994-1.995L399.6,425.08Z",
    transform: "translate(-370.37 -397.377)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2442",
    "data-name": "Group 2442",
    transform: "translate(0 7.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    className: "cls-2",
    d: "M406.526,299.889h-4.377V289.73a.469.469,0,0,0-.137-.331l-5.314-5.315a.469.469,0,0,0-.8.331v5.12l-5.177,5.177a.469.469,0,0,0-.137.331v4.845h-9.691V289.73a.469.469,0,0,0-.137-.331l-5.314-5.315-.016-.014-.027-.024-.028-.02-.029-.018-.033-.017-.019-.009-.011,0-.035-.012-.031-.009-.036-.006-.032,0h-.068l-.034,0-.034.006-.032.009-.035.011-.011,0-.019.01-.033.016-.029.018-.028.02-.027.024-.016.014-5.314,5.315a.469.469,0,0,0-.137.331v10.16h-9.691V284.415a.469.469,0,0,0-.8-.331L353.52,289.4a.469.469,0,0,0-.137.331v4.845h-4.846a.469.469,0,0,0-.469.469v4.846h-.819a.468.468,0,1,0,0,.937h59.276a.469.469,0,0,0,0-.937Zm-53.143,0h-4.377v-4.377h4.377Zm5.314,0H354.32v-9.965l4.377-4.377Zm15.943,0h-4.377v-9.965l4.377-4.377Zm5.314,0h-4.377V285.547l4.377,4.377Zm11.566-4.651,4.377-4.377v9.028h-4.377Zm5.314,4.651V285.547l4.377,4.377v9.965Z",
    transform: "translate(-327.28 -283.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    className: "cls-2",
    d: "M281.02,403.947h-1.5a.468.468,0,1,0,0,.937h1.5a.468.468,0,0,0,0-.937Z",
    transform: "translate(-268.549 -388.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    className: "cls-2",
    d: "M209.472,403.945h-9a.469.469,0,1,0,0,.937h9a.468.468,0,1,0,0-.937Z",
    transform: "translate(-200.001 -388.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    className: "cls-2",
    d: "M326.17,403.947h-1.5a.468.468,0,1,0,0,.937h1.5a.468.468,0,1,0,0-.937Z",
    transform: "translate(-307.7 -388.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    className: "cls-2",
    d: "M303.6,403.947h-1.5a.468.468,0,0,0,0,.937h1.5a.468.468,0,1,0,0-.937Z",
    transform: "translate(-288.129 -388.004)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerTatabaLogo);
export default __webpack_public_path__ + "static/media/drawer-tataba-logo.6fccb2ba05d94ebb6a3a575ffc9a57b0.svg";
export { ForwardRef as ReactComponent };